/**
 * Branch.io deep link notification types.
 *
 * These values come from the `notificationType` field in Branch link data.
 * Raw values must match exactly what the backend sends in Branch links.
 */
export enum BranchNotificationType {
  // Packages
  ResidentNewPackage = "ResidentNewPackage",
  ResidentPackageDelivered = "ResidentPackageDelivered",

  // Rent
  AutoPayReminder = "AutoPayReminder",
  FirstMonthRentFailure = "FirstMonthRentFailure",
  FirstMonthRentSuccess = "FirstMonthRentSuccess",
  RentSuccess = "RentSuccess",
  RentFailure = "RentFailure",
  RentSuccessAutoPay = "RentSuccessAutoPay",

  // Maintenance
  TicketCreated = "TicketCreated",
  TicketStatusChanged = "TicketStatusChanged",
  TicketChatMessageReceived = "TicketChatMessageReceived",

  // Insurance
  InsurancePaymentFailure = "InsurancePaymentFailure",
  InsurancePaymentSuccessAutoPay = "InsurancePaymentSuccessAutoPay",
  InsuranceProofApproved = "InsuranceProofApproved",
  InsuranceProofDenied = "InsuranceProofDenied",

  // Community Feed
  CommunityFeedPropertyManagerPost = "CommunityFeedPropertyManagerPost",
  CommunityFeedUserLike = "CommunityFeedUserLike",
  CommunityFeedLivlyPost = "CommunityFeedLivlyPost",
  CommunityFeedGroupPost = "CommunityFeedGroupPost",
  CommunityFeedResidentPost = "CommunityFeedResidentPost",
  CommunityFeedUserComment = "CommunityFeedUserComment",
  CommunityFeedPermissionRevoked = "CommunityFeedPermissionRevoked",

  // Guests
  KioskGuestNotification = "KioskGuestNotification",
  GuestPassApprovalNotification = "GuestPassApprovalNotification",

  // Messaging
  ResidentChatMessageReceived = "ResidentChatMessageReceived",

  // Polls
  ResidentPollPosted = "ResidentPollPosted",

  // Feedback
  AmenityBookingFeedbackReminder = "AmenityBookingFeedbackReminder",
  LivlyEventFeedbackReminder = "LivlyEventFeedbackReminder",
  MoveInFeedbackReminder = "MoveInFeedbackReminder",
  ResidentFeedbackReplyReceived = "ResidentFeedbackReplyReceived",

  // Events
  LivlyEvent1HourReminder = "LivlyEvent1HourReminder",
  LivlyEventReminder = "LivlyEventReminder",

  // Ambassador
  AmbassadorApplicationApproved = "AmbassadorApplicationApproved",
  AmbassadorApplicationDenied = "AmbassadorApplicationDenied",
  AmbassadorConversationEnded = "AmbassadorConversationEnded",
  AmbassadorOpportunityCreated = "AmbassadorOpportunityCreated",
  AmbassadorMessageReceived = "AmbassadorMessageReceived",
}

export interface BranchLinkData {
  notificationType: string;
  data: Record<string, string> | null;
}
